import { Flex } from '@radix-ui/themes';
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import useDecodeToken from '../hooks/useDecodeToken';
import { RootState } from '../redux/store';
import { isTokenValid } from '../utils/tokenValidation';
import Content from './Content';
import Sidebar from './Sidebar';
import { useFetchManager } from '../hooks/useFetchManager';

interface ContentProps {
  children: ReactNode;
}

const Layout: React.FC<ContentProps> = ({ children }) => {
  const isAuthenticated = isTokenValid();
  const decodeToken = useDecodeToken();
  const { fetchManager } = useFetchManager();

  const userData = useSelector((state: RootState) => state.login.userData);
  if (!userData.UserId) {
    decodeToken();
    fetchManager();
  }

  if (isAuthenticated) {
    return (
      <Flex
        style={{ height: '100dvh' }}
      >
        <Sidebar />
        <Content>
          {children}
        </Content>
      </Flex>
    );
  }

  return <>{children}</>;
};

export default Layout;